var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.qrCodeStream,{tag:"component",on:{"init":_vm.onInitQrcodeStream,"decode":_vm.onDecode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }